/**
 * MinistryRedirectGate — wraps the standard / landing. When edition
 * detection fires (the user has the ?edition=mohap dev override or a
 * stored localStorage flag), this redirects to /mohap. In production
 * the path prefix IS the detection signal, so the gate primarily
 * catches the dev-override and bookmark-from-landing cases — landing
 * directly on /mohap/* doesn't need the gate at all.
 *
 * For non-edition loads, renders the wrapped child untouched.
 *
 * The shell itself does the inverse guard (renders nothing if edition
 * isn't detected), so the two together make /mohap/* and the
 * default product mutually exclusive on a per-load basis.
 */

import { Navigate } from "react-router-dom";
import { useMinistryEdition } from "./hooks/useMinistryEdition";

interface Props {
  /** What to render when edition is the standard N71 product. */
  children: React.ReactNode;
  /** Optional override for where to redirect. Defaults to /mohap. */
  to?: string;
}

export function MinistryRedirectGate({ children, to = "/mohap" }: Props) {
  const { isWhiteLabel } = useMinistryEdition();
  if (isWhiteLabel) {
    return <Navigate to={to} replace />;
  }
  return <>{children}</>;
}
